import 'react';
import { ribbon, iconCls } from './atom.ribbon.style.js';
import { jsx } from 'react/jsx-runtime';

function Ribbon(props) {
  return /*#__PURE__*/jsx("span", {
    className: ribbon,
    children: /*#__PURE__*/jsx("i", {
      className: iconCls,
      children: props.children
    })
  });
}

export { Ribbon as default };
//# sourceMappingURL=atom.ribbon.js.map
